import firebaseConf from './conf'
import firebase from 'firebase'
// import * as firebaseAdmin from 'firebase-admin'

// var serviceAccount = require('./proyecto-agenda-35b23-91d433e19af2.json');

var app = firebase.initializeApp({
  apiKey: firebaseConf.FbApiKey,
  authDomain: firebaseConf.FbAuthDomain,
  projectId: firebaseConf.FbProjectId,
  storageBucket: firebaseConf.FbStorage,
});

var db = firebase.firestore();
var auth = firebase.auth(app);
var storage = firebase.storage(app);
/* var admin = firebaseAdmin.initializeApp({
  credential: firebaseAdmin.credential.cert(serviceAccount),
  databaseURL: firebaseConf.FbDB
}) */

export { db, auth, storage }